import Spinner from 'components/Spinner';
import React from 'react';
import { useEffect } from 'react';

const FrameRedirectHandler = () => {
  useEffect(() => {
    const status = new URLSearchParams(window.location.search).get('status');
    if (window.parent !== window) {
      window.parent.postMessage(JSON.stringify({
        eventType: 'payment_status',
        status: status || 'Unknown',
      }), '*');
    }
  }, []);

  return <Spinner isLoading={true}/>;
};

export default FrameRedirectHandler;
